import { EncounterTypes, ProcedureType } from "@vellum/vellum-api";

/**
 * Encounters that count as a patient seen (and billed), mapped to their
 * service line. Transfusion work is split into many encounters per patient
 * (calls, type & screen, pickup, follow-ups); only administration is the
 * billed visit, so the rest are left out to avoid counting a patient 5–7×.
 */
export const BILLED_ENCOUNTERS: Partial<Record<EncounterTypes, ProcedureType>> =
  {
    [EncounterTypes.INFUSION]: ProcedureType.INFUSION,
    [EncounterTypes.VASCULAR_ACCESS]: ProcedureType.VASCULAR_ACCESS,
    [EncounterTypes.BLOOD_TRANSFUSION_ADMINISTRATION]: ProcedureType.TRANSFUSION,
  };
